module.exports = __webpack_public_path__ + "static/img/4.4bffba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/4.png
// module id = LPOZ
// module chunks = 0